import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-WEB_BGXT",
  "use": "rt-portal-WEB_BGXT-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-WEB_BGXT\">\r\n<path d=\"M883.4,198H140.6c-15.8,0-28.6,12.8-28.6,28.5v570.9c0,15.8,12.8,28.5,28.6,28.5h742.9c15.8,0,28.6-12.8,28.6-28.5V226.5\r\n\tC912,210.8,899.2,198,883.4,198z M799.1,262.3L512,485.2L224.9,262.3H799.1z M847.7,296.8v464.9H176.3V296.8l-24.6-19.2l0,0\r\n\tl24.6,19.1l305,236.9c18,14,43.3,14,61.3,0L847.7,296.8l24.6-19.2h0.1L847.7,296.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/WEB_BGXT.svg
// module id = 1225
// module chunks = 96